<template>
<el-card>
    <el-radio-group v-model="activeName" @change="goPage">
        <el-radio-button label="list">列表</el-radio-button>
        <el-radio-button label="map">地图</el-radio-button>
    </el-radio-group>
    <router-view></router-view>
</el-card>
</template>

<script>
  export default {
    name: 'SeedlingBase',
    props: {
    },
    components: {
    },
    data () {
      return {
        activeName: 'list'
      }
    },
    computed: {
    },
    created () {
      this.activeName = this.$route.path.substr(this.$route.path.lastIndexOf('/') + 1)
      this.goPage(this.activeName)
    },
    mounted () {
    },
    beforeDestroy () {
    },
    methods: {
      goPage (value) {
        if (value === 'map') {
          // 缓存地图
          this.$store.commit('addKeepAlive', 'SeedlingBase')
        } else {
          this.$store.commit('removeKeepAlive', 'SeedlingBase')
        }
        this.$router.push({ path: `/seedlingList/${value}` })
      }
    }
  }
</script>
<style lang="scss">
.el-card .el-radio-group {
    margin-bottom: 20px;
}
</style>
